<template>
  <tile-basic
    class="is-info"
    :values="keyValues(pkg)"
    :title="title"
    img="pkg"
    headerImg="pkg">
  </tile-basic>
</template>

<script>
import mixin from '@/mixins/packages';
import TileBasic from '@/components/TileBasic.vue';

export default {
  name: 'TilePackage',
  mixins: [mixin],
  components: {
    TileBasic,
  },
  props: {
    pkg: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Package Info',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.paddding {
  padding: 1rem;
}

</style>
